import React, { useRef, useState, useEffect } from "react";
import DsModal from "../_UI/dsModal";
import Form from "../_UI/dsModal/form.module.scss";
import AvatarEditor from "react-avatar-editor";
import Styles from "./styles.module.scss";
import { useDispatch, useSelector } from "react-redux";
import {changeAvatar, setSettingsAvatarModalStatus} from "../../store/cabinet/action";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";

const CabinetSettingsAvatarModal = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const settingsAvatarModalStatus = useSelector((store) => store.cabinet.settingsAvatarModalStatus);

    const editorRef = useRef(null);
    // Создаём ref для input file
    const fileInputRef = useRef(null);
    const [scale, setScale] = useState(1);
    const [image, setImage] = useState(null);

    // Состояние для динамических размеров редактора
    const [editorSize, setEditorSize] = useState({
        width: window.innerWidth > 767 ? 240 : 200,
        height: window.innerWidth > 767 ? 240 : 200,
    });

    // Обновление размеров редактора при изменении размера окна
    useEffect(() => {
        const updateEditorSize = () => {
            if (window.innerWidth > 767) {
                setEditorSize({ width: 240, height: 240 });
            } else {
                setEditorSize({ width: 200, height: 200 });
            }
        };

        window.addEventListener("resize", updateEditorSize);
        // Вызовем сразу, чтобы установить корректные размеры при монтировании
        updateEditorSize();

        return () => {
            window.removeEventListener("resize", updateEditorSize);
        };
    }, []);

    const closeModal = () => {
        dispatch(setSettingsAvatarModalStatus(false));
        setScale(1);
        setImage(null);
    };

    const handleScaleChange = (e) => {
        const scaleValue = parseFloat(e.target.value);
        setScale(scaleValue);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Создаём URL для выбранного файла
            const imageUrl = URL.createObjectURL(file);
            setImage(imageUrl);
        }
    };

    const handleSave = () => {
        if (editorRef.current) {
            const canvas = editorRef.current.getImageScaledToCanvas();
            // Преобразуем canvas в Blob
            canvas.toBlob((blob) => {
                if (blob) {
                    const file = new File([blob], 'avatar.png', { type: 'image/png' });
                    const formData = new FormData();
                    formData.append('avatar', file);
                    dispatch(changeAvatar(formData));
                    toast(t('Ваш аватар успешно изменён!'));
                    closeModal();
                }
            }, 'image/png'); // можно указать "image/jpeg", если требуется
        }
    };

    // Функция для симуляции клика по скрытому input
    const triggerFileSelect = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    return (
        <DsModal
            open={settingsAvatarModalStatus}
            onClose={closeModal}
            size="sm"
            title={t('Сменить аватар')}
        >
            <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{display: "none"}}
            />
            {image ? (
                <div className={Styles.editor}>
                    <AvatarEditor
                        ref={editorRef}
                        image={image}
                        width={editorSize.width}
                        height={editorSize.height}
                        border={30}
                        color={[2, 3, 7, 0.7]}
                        borderRadius={editorSize.width / 2}
                        scale={scale}
                        rotate={0}
                    />
                </div>
            ) : (
                <button type="button" className={Styles.dropzone} onClick={triggerFileSelect}>
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                        <path d="M21 15V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V15M17 8L12 3L7 8M12 3V15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>{t('Загрузите изображение для редактирования')}</span>
                </button>
            )}
            {image ? (
                <div className={Styles.range}>
                    <span>−</span>
                    <input
                        type="range"
                        min="1"
                        max="3"
                        step="0.01"
                        value={scale}
                        onChange={handleScaleChange}
                        style={{'--fill': `${((scale - 1) / 2) * 100}%`}}
                    />
                    <span>+</span>
                </div>
            ) : null}
            <div className={Form.actions}>
                <button type="button" className={Form.btnNeutral} onClick={triggerFileSelect}>{t('Выбрать файл')}</button>
                {image ? <button type="button" className={Form.btnAccent} onClick={handleSave}>{t('Сохранить')}</button> : null}
            </div>
        </DsModal>
    );
};

export default CabinetSettingsAvatarModal;
